<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="37.2" height="52.2" viewBox="0 0 37.2 52.2">
    <g id="Gruppe_118" data-name="Gruppe 118" transform="translate(-228.9 -115.9)">
      <g id="Gruppe_138" data-name="Gruppe 138" transform="translate(230 117)">
        <path id="Pfad_106" data-name="Pfad 106" d="M255.789,117H233.684A3.947,3.947,0,0,0,230,121.167v41.667A3.947,3.947,0,0,0,233.684,167h27.632A3.948,3.948,0,0,0,265,162.833V127.417h-9.211Z" transform="translate(-230 -117)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
        <path id="Pfad_107" data-name="Pfad 107" d="M258,117v5.417h5.417Z" transform="translate(-228.416 -117)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
      </g>
      <g id="Gruppe_139" data-name="Gruppe 139" transform="translate(241.536 153.291)">
        <path id="Pfad_108" data-name="Pfad 108" d="M249.912,155H238a.005.005,0,1,1,0-.011h11.917a.005.005,0,0,1,0,.011Z" transform="translate(-237.99 -152.282)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
        <path id="Pfad_109" data-name="Pfad 109" d="M249.912,150H238a.005.005,0,1,1,0-.011h11.917a.005.005,0,0,1,0,.011Z" transform="translate(-237.99 -149.99)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
      </g>
      <g id="_Group_" data-name="&lt;Group&gt;" transform="translate(242.625 129.917)">
        <circle id="Ellipse_24" data-name="Ellipse 24" cx="2.438" cy="2.438" r="2.438" transform="translate(2.437)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
        <path id="Pfad_110" data-name="Pfad 110" d="M249.75,140.2v-.867a2.445,2.445,0,0,0-2.437-2.437h-4.875A2.445,2.445,0,0,0,240,139.337v.867Z" transform="translate(-240 -131.537)" fill="none" stroke="#a8a8a8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
name: "myAccount"
}
</script>

<style scoped>

</style>